<div class="app-layout" [class.app-layout--no-sidebar]="hideSidebar">
    <header class="mobile-header" aria-label="Barra superior">
        <div class="mobile-header__left">
            @if (showMobileBack) {
                <button type="button" class="mobile-header__back" (click)="mobileGoBack()">
                    <fa-icon [icon]="icons.fasChevronLeft" class="mobile-header__back-icon" aria-hidden="true" />
                    <span class="mobile-header__back-label">Volver</span>
                </button>
            } @else {
                <button type="button" class="mobile-header__menu-btn" (click)="toggleSidebar()"
                    [attr.aria-expanded]="isSidebarOpen" aria-controls="personas-sidebar-panel" title="Menú">
                    <fa-icon [icon]="icons.fasBars" aria-hidden="true" />
                </button>
            }
        </div>
        <div class="mobile-header__center">
            <img src="assets/logo_corecredit_2.png" alt="CoreCredit" class="mobile-header__logo" width="120" height="32"
                loading="eager" />
        </div>
        <div class="mobile-header__right">
            <a routerLink="/personas/mis-datos" class="mobile-header__profile" aria-label="Ir a Mi perfil" title="Mi perfil">
                <span class="mobile-header__profile-box" aria-hidden="true">
                    <fa-icon [icon]="icons.farUser" class="mobile-header__profile-icon" />
                </span>
            </a>
        </div>
    </header>

    @if (!hideSidebar) {
        <div class="sidebar-overlay" [class.show]="isSidebarOpen" (click)="closeSidebar()" aria-hidden="true"></div>

        <aside id="personas-sidebar-panel" class="left-sidebar" [class.mobile-open]="isSidebarOpen"
            role="navigation" aria-label="Menú principal">
            <app-personas-sidebar></app-personas-sidebar>
        </aside>
    }

    <main class="main-content">
        <div class="content-container">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
